import pluralize from 'pluralize';
import { Link, useSearchParams } from 'react-router-dom';
import { useGetRegister } from '@/modules/issuer-dashboard/hooks/useGetRegister.tsx';
import { issuerDashboardPaths } from '@/modules/issuer-dashboard/routes.tsx';
import { BaseModalProps, ModalContentWrapper } from 'ui';
import { CorrespondenceHolder } from 'api';

interface CommunicationRecipientsModalProps extends BaseModalProps {
  holders: CorrespondenceHolder[];
}

const CommunicationRecipientsModal = ({
  open,
  holders,
  onClose,
}: CommunicationRecipientsModalProps) => {
  const [params] = useSearchParams();
  const register = useGetRegister();
  return (
    <ModalContentWrapper
      title={holders.length + pluralize(' Recipient', holders.length)}
      open={open}
      onClose={onClose}
    >
      <div className="max-h-[450px] relative overflow-auto">
        <table className="w-full text-xs">
          <thead className="sticky top-0 z-[2]">
            <tr className="border-b bg-gray-100 text-gray-500 py-2 h-9">
              <td className="w-24 pl-3">Name</td>
              <td>Email</td>
              <td className="pr-3">ID</td>
            </tr>
          </thead>
          <tbody>
            {holders
              .filter(({ recipient_email }) => recipient_email !== register?.correspondence_email)
              .map(({ recipient_email, shareholder }, index) => (
                <tr
                  key={recipient_email + (shareholder?.id || index)}
                  className="h-[38px] [&:not(:last-child)]:border-b"
                >
                  <td className="pl-3">
                    {shareholder ? (
                      <Link
                        to={{
                          pathname: issuerDashboardPaths.dynamic.holder(
                            shareholder.entity_id.toString(),
                          ),
                          search: params.toString(),
                        }}
                        className="block w-44 max-w-44 truncate text-blue-700 hover:underline"
                      >
                        {shareholder.entity.entity_name}
                      </Link>
                    ) : (
                      '---'
                    )}
                  </td>
                  <td>
                    <a
                      href={`mailto:${recipient_email}`}
                      className="block max-w-52 truncate hover:underline"
                    >
                      {recipient_email}
                    </a>
                  </td>
                  <td>{shareholder?.entity?.entity_id || '---'}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </ModalContentWrapper>
  );
};

export default CommunicationRecipientsModal;
